import { useState } from "react";
import { PhysShell, Field, ResultCard, Stat, primaryBtn, PHYS_ACCENT } from "./PhysShell.jsx";
import { kineticEnergy, potentialEnergy, work, round } from "./physcore.js";

const MODES = [
  ["ke", "Kinetic"],
  ["pe", "Potential"],
  ["work", "Work"],
];

export default function Energy() {
  const [mode, setMode] = useState("ke");
  const [a, setA] = useState("2");
  const [b, setB] = useState("3");
  const [c, setC] = useState("0");
  const [res, setRes] = useState(null);

  const go = () => {
    const A = parseFloat(a), B = parseFloat(b), C = parseFloat(c);
    if (mode === "ke") setRes({ ...kineticEnergy(A, B), label: "Kinetic energy" });
    else if (mode === "pe") setRes({ ...potentialEnergy(A, B), label: "Potential energy" });
    else setRes({ ...work(A, B, C), label: "Work done" });
  };

  const fields =
    mode === "ke"
      ? [["Mass m", "kg", a, setA], ["Velocity v", "m/s", b, setB]]
      : mode === "pe"
      ? [["Mass m", "kg", a, setA], ["Height h", "m", b, setB]]
      : [["Force F", "N", a, setA], ["Distance d", "m", b, setB], ["Angle θ", "°", c, setC]];

  return (
    <PhysShell title="Energy & Work">
      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        {MODES.map(([k, label]) => (
          <button
            key={k}
            onClick={() => { setMode(k); setRes(null); }}
            style={{ flex: 1, background: mode === k ? PHYS_ACCENT : "#1C1E2E", color: mode === k ? "#02232E" : "#9A9DBE", border: "none", borderRadius: 10, padding: "10px 0", fontWeight: 600, fontSize: 14, cursor: "pointer" }}
          >
            {label}
          </button>
        ))}
      </div>
      {fields.map(([label, unit, val, setter]) => (
        <Field key={label} label={label} suffix={unit} value={val} onChange={(e) => setter(e.target.value)} />
      ))}
      <button onClick={go} style={primaryBtn}>Calculate</button>
      {res && !res.ok && <ResultCard><span style={{ color: "#F8716A" }}>{res.error}</span></ResultCard>}
      {res && res.ok && (
        <ResultCard>
          <Stat label={res.label} value={round(res.result, 4)} unit="J" />
          <div style={{ marginTop: 12, fontSize: 13, color: "#9A9DBE" }}>Used: {res.formula}</div>
          {(() => {
            const A = Number(a), B = Number(b), C = Number(c), R = round(res.result, 4);
            let sub;
            if (mode === "ke") sub = `KE = ½(${A})(${B}²) = ${R} J`;
            else if (mode === "pe") sub = `PE = (${A})(9.81)(${B}) = ${R} J`;
            else sub = `W = (${A})(${B})·cos(${C}°) = ${R} J`;
            return (
              <div style={{ marginTop: 8, fontSize: 12.5, color: "#C8CADF", fontFamily: "ui-monospace, monospace" }}>
                {sub}
              </div>
            );
          })()}
        </ResultCard>
      )}
    </PhysShell>
  );
}

